export default "__VITE_ASSET__BRNqHfPf__"